export default __webpack_public_path__ + "static/media/rocket_anim_19.2026ad4b.png";